import script from "./JobsProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./JobsProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./JobsProgressBar.vue?vue&type=style&index=0&id=64195887&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64195887"]])

export default __exports__